import $ from 'jquery';
var router = ['/person/positionIndex', '/project'];

$(function () {
  var href = window.location.href;
  $('.filter_box').hide();
  window.addEventListener('scroll', function () {
    let t = $('body, html').scrollTop();
    if (t > 40) {
      $('#filter_combo').addClass('nav_fixed');
      $('#new_search_box').addClass('whiteBackground');
      
      if (router.indexOf(window.$vue.$route.fullPath) > -1) {
        $('.top_header').hide();
        $('.new_nav_list').hide();
        $('.filter_box').show();
      }
    } else {
      $('#filter_combo').removeClass('nav_fixed');
      $('#new_search_box').removeClass('whiteBackground');
      $('.new_nav_list').show();
      $('.top_header').show();
      $('.filter_box').hide();
    }

    if (t > 35) {
      $('.rt_nav_box').addClass('scroll_rt_nav_box');
    } else {
      $('.rt_nav_box').removeClass('scroll_rt_nav_box');
    }
  });
});

// 递归检索
export function handleTreeData(treeData, searchValue) {
  if (!treeData || treeData.length === 0) {
    return [];
  }
  const array = [];
  for (let i = 0; i < treeData.length; i += 1) {
    let match = false;
    for (const pro in treeData[i]) {
      if (typeof treeData[i][pro] === 'string') {
        match |= treeData[i][pro].toUpperCase().includes(searchValue);
        if (match) break;
      }
    }
    if (handleTreeData(treeData[i].children, searchValue).length > 0 || match) {
      array.push({ ...treeData[i], children: handleTreeData(treeData[i].children, searchValue) });
    }
  }
  return array;
}

// 处理树形数据，只保留到城市级别（第二层）
export function filterCityData(data, level = 1) {
  // 复制一份数据避免修改原数据
  return data.map((item) => {
    const newItem = { ...item };

    // 如果是第二层（城市级别），移除children或设置为空
    if (level === 2) {
      delete newItem.children;
      return newItem;
    }

    // 如果有子节点且不是第三层，继续递归处理
    if (newItem.children && level < 2) {
      newItem.children = filterCityData(newItem.children, level + 1);
    }

    return newItem;
  });
}
